<script setup>
import { defineProps, defineEmits, computed } from "vue";
import InputWrapper from "./InputWrapper";
import AtomIcon from "@/common/ui/Icon.vue";
const emits = defineEmits(["update:modelValue", "findClick", "keyupEnter"]);

const updateValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits("update:modelValue", value);
  },
});

const props = defineProps({
  id: {
    type: String,
    default: "",
  },
  placeholder: {
    type: String,
    default: "",
  },
  label: {
    type: String,
    default: "",
  },
  name: {
    type: String,
    default: "",
  },
  class: {
    type: String,
    default: "",
  },
  autocomplete: {
    type: String,
    default: "",
  },
  disabled: Boolean,
  modelValue: {
    type: String,
    default: "",
  },
  error: {
    type: Boolean,
    default: false,
  },
  errors: {
    type: Array,
    default: () => [],
  },
});

const onFindClick = (e) => {
  emits("findClick", e);
};

const onKeyupEnter = (e) => {
  emits("keyupEnter", e);
};
</script>

<template>
  <InputWrapper
    :id="id"
    :label="label"
    :class="props.class"
    :disabled="disabled"
    :error="error"
    :errors="errors"
  >
    <input
      :id="id"
      v-model="updateValue"
      :name="name"
      :autocomplete="autocomplete"
      type="text"
      :disabled="disabled"
      :placeholder="placeholder"
      @keyup.enter="onKeyupEnter"
    />
    <AtomIcon v-if="!disabled" name="search" @click="onFindClick" />
  </InputWrapper>
</template>

<style lang="scss" scoped>
@import "/src/modules/ras/views/index";
@import "../../assets/theme/default/colors";

:deep() {
  .form-control {
    display: flex;

    &--disabled {
      background-color: $white-mist-bg;
    }
  }

  .control-label {
    font-weight: 400 !important;
    color: $gray-dark;
    font-size: 16px;
  }

  .error-message {
    color: red;
    font-size: 0.75rem;
  }
}
.form-control {
  input {
    border: 0;
    flex: 1;
    &:focus {
      outline: none;
    }
  }
  .icon {
    color: $gray-medium;
    cursor: pointer;
  }
}
</style>
